function initHamburgers() {
  const mobileHamburger = document.querySelector('[data-mobile-hamburger]');
  const items = document.querySelectorAll('[data-item]');
  if (items) {
    items.forEach((item) => {
      item.addEventListener('click', (e) => {
        const allShits = document.querySelectorAll('[data-item]._opened');
        allShits.forEach((shit) => {
          shit.classList.remove('_opened');
        });
        if (!item.classList.contains('_opened')) {
          item.classList.add('_opened');
        }
      });
    });
  }
  if (mobileHamburger) {
    mobileHamburger.addEventListener('click', (e) => {
      const menu = document.querySelector('[data-expand-block]');
      if (!menu.classList.contains('_opened')) {
        menu.classList.add('_opened');
        mobileHamburger.classList.add('_opened');
      } else {
        menu.classList.remove('_opened');
        mobileHamburger.classList.remove('_opened');
      }
    });
  }
}
document.addEventListener('DOMContentLoaded', initHamburgers);